import { CCStyling } from "../../cclib/CCStyling";
import { CCStructureItem } from "../../cclib/types/structure";
import { instructionsStyling } from "../shared/structure";

export const afcsStructure: CCStructureItem[] = [
  {
    type: "header",
    htmlAttributes: { "data-collapse-mark": "0" },
    name: "Instructions"
  },
  {
    type: "instructions",
    text: "There are seven separate sections to this form.  Where possible, data has been automated from your CV to fill in the relevant content to help streamline this form.  When content is missing or unavailable, please update your CV as the source of record and the updates will flow through to this form. When you conclude the survey, please click the Submit button.",
    additionalCss: instructionsStyling
  },
  {
    type: "header",
    name: "Info"
  },
  {
    type: "string",
    key: "faculty_rank",
    name: "Faculty Rank"
  },
  {
    type: "string",
    key: "faculty_line",
    name: "Faculty Line"
  },
  {
    type: "string",
    key: "fte",
    name: "FTE Percentage"
  },
  {
    type: "string",
    key: "primary_mentor",
    name: "Primary Mentor",
    yearAgnostic: true
  },
  {
    type: "header",
    htmlAttributes: { "data-collapse-mark": "I" },
    name: "I.\tShort Answer Questions"
  },
  /* Wellness {
    type: "header",
    name: "Wellness Initiatives"
  },
  {
    type: "instructions",
    text: "Have you engaged in Wellness Initiatives (initiatives you attended or engaged in to promote your own wellness)? Check all that apply:",
    additionalCss: instructionsStyling
  },
  {
    type: "check",
    key: "wellness_no",
    name: "No"
  },
  {
    type: "check",
    key: "wellness_yes_bewell",
    name: "Yes, Stanford BeWell"
  },
  {
    type: "check",
    key: "wellness_yes_initiative",
    name: "Yes, EM Department Wellness Initiative"
  },
  {
    type: "check",
    key: "wellness_yes_other",
    name: "Yes, Other"
  }, */
  /* DEI
  {
    type: "instructions",
    text: "Contributions to Diversity and Inclusion (if applicable, please share information about your contributions to diversity and inclusion):",
    additionalCss: CCStyling.join(
      instructionsStyling,
      CCStyling.fromObject({ "margin-top": "15px" })
    )
  },
  {
    type: "paragraph",
    key: "dei_contribution_a",
    name: "a",
    wordLimit: 15
  },
  {
    type: "paragraph",
    key: "dei_contribution_b",
    name: "b",
    wordLimit: 15
  },
  {
    type: "paragraph",
    key: "dei_contribution_c",
    name: "c",
    wordLimit: 15
  },
  */
  {
    type: "header",
    name: "Leave and Vacation Plans"
  },
  {
    type: "select",
    key: "planning_leave",
    name: "Planning leave in upcoming academic year?",
    options: ["Yes", "No"]
  },
  {
    type: "select",
    key: "planning_vacation",
    name: "Planning vacation in upcoming academic year?",
    options: ["Yes", "No"]
  },
  {
    type: "header",
    htmlAttributes: { "data-collapse-mark": "II" },
    name: "II.\tCOURSES directed, lectured, or taught"
  },
  {
    type: "instructions",
    text: "Number of hours lectured or taught for Clerkship, Residents/Fellows, or Faculty Development. Note, details of these presentations are not captured in AFCS, only the overall number of hours",
    additionalCss: instructionsStyling
  },
  {
    type: "string",
    key: "hours_clerkship",
    name: "Total hours teaching CLERKSHIP curriculum"
  },
  {
    type: "string",
    key: "hours_resident",
    name: "Total hours teaching RESIDENT/FELLOWS curriculum"
  },
  {
    type: "string",
    key: "hours_faculty",
    name: "Total hours teaching FACULTY DEVELOPMENT curriculum"
  },
  {
    type: "header",
    name: "Courses (from Teaching and Clinical Care – Other Teaching Experience)",
    htmlAttributes: {
      "data-key": "courses_jump_binding"
    }
  },
  {
    type: "instructions",
    text: "If any courses are missing, please add them to your CV",
    additionalCss: CCStyling.join(
      CCStyling.fromObject({ "margin-bottom": "0" }),
      instructionsStyling
    )
  },
  {
    type: "custom",
    key: "custom-courses"
  },
  {
    type: "select",
    key: "planning_new_course",
    name: "Do you plan to direct, lecture, or teach a new course in the next academic year?",
    options: ["Yes", "No"]
  },
  {
    type: "instructions",
    text: "If you are the Course Director or Co-Director for any course for the upcoming academic year, please schedule a 30-minute meeting with the Vice Chair of Education to review your teaching evaluations and course budget.",
    additionalCss: CCStyling.join(
      instructionsStyling,
      CCStyling.fromObject({ "margin-top": "30px" })
    )
  },
  {
    type: "header",
    // name: "III.\tGrants Submitted",
    name: "", // Name will be set by `updateAFCS` in `afcs.ts`
    htmlAttributes: {
      "data-collapse-mark": "III",
      "data-key": "gs_academic_year_replace"
    }
  },
  {
    type: "header",
    name: "Key terminology"
  },
  {
    type: "instructions",
    text: "Every grant has a PRIME sponsor. Only include a DIRECT sponsor if your grant is a sub-award. If your grant is a sub-award, the PRIME sponsor is the originating source of funds, the DIRECT sponsor is the organization giving us the funds.",
    additionalCss: instructionsStyling
  },
  {
    type: "instructions",
    text: "Example: if your grant is a sub-award to UCSF on an NIH grant, NIH would be the PRIME sponsor and UCSF would be the DIRECT sponsor.",
    additionalCss: CCStyling.join(
      CCStyling.fromObject({ "font-style": "italic" }),
      instructionsStyling
    )
  },
  {
    type: "header",
    name: "Grants (from Other Study and Research Opportunities)",
    htmlAttributes: {
      "data-key": "grants_jump_binding"
    }
  },
  {
    type: "instructions",
    text: "If any grants are missing, please add them to your CV",
    additionalCss: instructionsStyling
  },
  {
    type: "custom",
    key: "custom-grants"
  },
  {
    type: "header",
    name: "IV.\tPublications",
    htmlAttributes: {
      "data-collapse-mark": "IV",
      "data-key": "publications_header_sync_binding"
    }
  },
  {
    type: "instructions",
    text: "Please run the PubMed Import tool to bring publications in your CV up to date before completing this section of the form. If any publications are missing from this list, please update your CV as the source of record and the updates will flow through to this form.",
    additionalCss: instructionsStyling
  },
  {
    type: "header",
    name: "Peer Reviewed Original Research",
    htmlAttributes: {
      "data-key": "peer_original_jump_binding"
    }
  },
  {
    type: "custom",
    key: "custom-peer-original"
  },
  {
    type: "header",
    name: "Peer Reviewed Other",
    htmlAttributes: {
      "data-key": "peer_other_jump_binding"
    }
  },
  {
    type: "custom",
    key: "custom-peer-other"
  },
  {
    type: "header",
    name: "Peer Reviewed Review Articles",
    htmlAttributes: {
      "data-key": "peer_articles_jump_binding"
    }
  },
  {
    type: "custom",
    key: "custom-peer-articles"
  },
  {
    type: "header",
    name: "Abstracts",
    htmlAttributes: {
      "data-key": "abstracts_jump_binding"
    }
  },
  {
    type: "custom",
    key: "custom-abstracts"
  },
  {
    type: "header",
    name: "Book Chapters",
    htmlAttributes: {
      "data-key": "chapters_jump_binding"
    }
  },
  {
    type: "custom",
    key: "custom-chapters"
  },
  {
    type: "header",
    name: "Books",
    htmlAttributes: {
      "data-key": "books_jump_binding"
    }
  },
  {
    type: "custom",
    key: "custom-books"
  },
  {
    type: "header",
    name: "Book Reviews",
    htmlAttributes: {
      "data-key": "book_reviews_jump_binding"
    }
  },
  {
    type: "custom",
    key: "custom-book-reviews"
  },
  {
    type: "header",
    name: "Digital Publications",
    htmlAttributes: {
      "data-key": "digital_pub_jump_binding"
    }
  },
  {
    type: "custom",
    key: "custom-digital-pub"
  },
  {
    type: "header",
    name: "V.\tInvited Presentations",
    htmlAttributes: {
      "data-collapse-mark": "V",
      "data-key": "presentations_header_sync_binding"
    }
  },
  {
    type: "header",
    name: "Summary"
  },
  {
    type: "custom",
    key: "custom-pres-summary"
  },
  {
    type: "header",
    name: "Local",
    htmlAttributes: {
      "data-key": "pres_local_jump_binding"
    }
  },
  {
    type: "custom",
    key: "custom-pres-local"
  },
  {
    type: "header",
    name: "Regional",
    htmlAttributes: {
      "data-key": "pres_regional_jump_binding"
    }
  },
  {
    type: "custom",
    key: "custom-pres-regional"
  },
  {
    type: "header",
    name: "National",
    htmlAttributes: {
      "data-key": "pres_national_jump_binding"
    }
  },
  {
    type: "custom",
    key: "custom-pres-national"
  },
  {
    type: "header",
    name: "International",
    htmlAttributes: {
      "data-key": "pres_international_jump_binding"
    }
  },
  {
    type: "custom",
    key: "custom-pres-international"
  },
  {
    type: "header",
    name: "VI.\tCommittees",
    htmlAttributes: {
      "data-collapse-mark": "VI",
      "data-key": "committees_header_sync_binding"
    }
  },
  {
    type: "header",
    name: "Department of Emergency Medicine"
  },
  {
    type: "header",
    name: "Academic Committee Type: Not Selected",
    htmlAttributes: {
      "data-key": "committee_not_jump_binding"
    }
  },
  {
    type: "custom",
    key: "custom-committee-not"
  },
  {
    type: "header",
    name: "Academic Committee Type: Local",
    htmlAttributes: {
      "data-key": "committee_local_jump_binding"
    }
  },
  {
    type: "custom",
    key: "custom-committee-local"
  },
  {
    type: "header",
    name: "Academic Committee Type: Regional",
    htmlAttributes: {
      "data-key": "committee_regional_jump_binding"
    }
  },
  {
    type: "custom",
    key: "custom-committee-regional"
  },
  {
    type: "header",
    name: "Academic Committee Type: National",
    htmlAttributes: {
      "data-key": "committee_national_jump_binding"
    }
  },
  {
    type: "custom",
    key: "custom-committee-national"
  },
  {
    type: "header",
    name: "Academic Committee Type: International",
    htmlAttributes: {
      "data-key": "committee_international_jump_binding"
    }
  },
  {
    type: "custom",
    key: "custom-committee-international"
  },
  {
    type: "header",
    name: "Committees – University Level"
  },
  {
    type: "header",
    name: "University Administrative Service",
    htmlAttributes: {
      "data-key": "committee_uni_jump_binding"
    }
  },
  {
    type: "custom",
    key: "custom-committee-uni"
  },
  {
    type: "header",
    htmlAttributes: { "data-collapse-mark": "VII" },
    name: "VII.\tConcluding Questions"
  },
  {
    type: "header",
    name: "Goals"
  },
  {
    type: "instructions",
    text: "Please list three ACTIONABLE and MEASURABLE goals for the upcoming year.",
    additionalCss: instructionsStyling
  },
  {
    type: "instructions",
    text: "These will be discussed, and can be refined, during this year's meeting with your AFCS interviewer. Progress on these goals will be re-evaluated during next year's AFCS.",
    additionalCss: instructionsStyling
  },
  {
    type: "paragraph",
    key: "goal_1",
    name: "Goal 1"
  },
  {
    type: "paragraph",
    key: "goal_2",
    name: "Goal 2"
  },
  {
    type: "paragraph",
    key: "goal_3",
    name: "Goal 3"
  },
  {
    type: "header",
    name: "Professional Reputation",
    htmlAttributes: { "data-reputation-mark": "start" }
  },
  {
    type: "instructions",
    text: "Full Professors and Fellows: Skip this section!",
    additionalCss: instructionsStyling
  },
  {
    type: "instructions",
    text: "Associate Professors and Assistant Professors:",
    additionalCss: instructionsStyling
  },
  {
    type: "instructions",
    text: "Please list four individuals (at least two external to Stanford University) who can attest to your professional reputation. Ideally, these individuals will not be the same names submitted last year",
    additionalCss: instructionsStyling
  },
  {
    type: "instructions",
    text: "Associate Professors: with regard to your NATIONAL reputation.",
    additionalCss: instructionsStyling
  },
  {
    type: "instructions",
    text: "Assistant Professors: with regard to your REGIONAL reputation.",
    additionalCss: instructionsStyling
  },
  {
    type: "custom",
    key: "custom-reputation"
  },
  {
    type: "header",
    name: "Final Thoughts",
    htmlAttributes: { "data-reputation-mark": "end" }
  },
  {
    type: "paragraph",
    key: "final_1",
    text: "1. How could your talents be well utilized in the Department?"
  },
  {
    type: "paragraph",
    key: "final_2",
    text: "2. What is one thing you would like the chance to learn more about?"
  },
  {
    type: "paragraph",
    key: "final_3",
    text: "3. Any other key information on your efforts this year not captured on AFCS? You may either enter a response in the field below or attach a document (optional)",
    htmlAttributes: { "data-attachment-button-mark": "" }
  },
  {
    type: "paragraph",
    key: "final_4",
    text: "4. Any specific topics you would like to discuss during your AFCS? (Do not enter confidential information)"
  },
  {
    type: "paragraph",
    key: "final_5",
    text: "If you have comments or suggestions about the AFCS form itself, feel free to add them here:"
  }
];
